import builder from '../builder';
import BoxCorner3D from '../../streamline-icons/light/3d-box-corner.svg';

export default builder('IconBoxCorner3DLight', BoxCorner3D);
